export default __webpack_public_path__ + "assets/css/typography.637bd34b1dfa3d88e7113e409128c948.css";